import { render, staticRenderFns } from "./GraphStat.vue?vue&type=template&id=1d35534e&"
import script from "./GraphStat.vue?vue&type=script&lang=js&"
export * from "./GraphStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d35534e')) {
      api.createRecord('1d35534e', component.options)
    } else {
      api.reload('1d35534e', component.options)
    }
    module.hot.accept("./GraphStat.vue?vue&type=template&id=1d35534e&", function () {
      api.rerender('1d35534e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/dashboard/GraphStat.vue"
export default component.exports